import collection from 'lodash/collection'
import _ from 'lodash'
import moment from 'moment'
import { OrderItem } from '../models/order'

export function calculateDishsTotal (order) {
  return (order.list || order || []).reduce((accumulator, currentValue) => {
    return accumulator + currentValue.total
  }, 0)
}

export function calculateOptionsTotal (order) {
  const options = collection.flatMapDeep((order.list || order || []).map(item => {
    const itemOptions = (item.items || []).map(item => item.options)
    return item.options.concat(itemOptions)
  }))

  return options.reduce((accumulator, currentValue) => {
    if (typeof currentValue.quantity !== 'undefined') {
      return accumulator + currentValue.price * currentValue.quantity
    } else {
      return accumulator + currentValue.price
    }
  }, 0)
}

export function calculateOrders (
  orders,
  merchant,
  discount,
  shipping,
) {
  if (!discount) {
    discount = { percent: 0, amount: 0, overrideItem: false }
  }
  if (!('overrideItem' in discount)) {
    discount.overrideItem = true // REMIND: dont know why imply true, takeaway promocode seems always true
  }
  let total = 0
  let discountedItemTotal = 0
  let excludedDiscountItemTotal = 0
  _.each(orders, order => {
    let items
    if (!order.items && !order.item) {
      items = [order]
    } else {
      items = (order.items || [order.item]).filter(o => o)
    }
    _.each(items, o => {
      let options = order.options || o.options
      // TODO: like hardcode fix, need to consolidate function input, wht is orders
      if (!_.get(order, 'options.length') && _.has(o.options, '0.stepperValue')) {
        options = o.options
      }
      if (!_.get(order, 'options.length') && _.get(o, 'options.length')) {
        options = o.options
      }

      const item = new OrderItem({
        ..._.cloneDeep(o),
        quantity: o.quantity || order.quantity,
        options,
      })
      const price = item.getPrice()
      total += price
      if (
        (item.excludedDiscount || _.get(item, 'item.excludedDiscount')) &&
        !discount.overrideItem
      ) {
        excludedDiscountItemTotal += price
      } else {
        discountedItemTotal += price * ((100 - discount.percent) * 0.01)
      }
    })
  })

  let discountedTotal = excludedDiscountItemTotal + discountedItemTotal - discount.amount

  // surcharge
  const weekdayIndex = new Date().getDay() // get the index of weekday. 0 = sunday, 1 = monday, etc...
  const defaultSurcharge = _.get(merchant, ['surcharge'], { percent: 0 }) //  default surcharge object with two keys: percent and amount.
  const openingsWithSurcharge = _.get(merchant, ['openingsWithSurcharge'], []) // array of array of objects.

  const periodIndex = _.findIndex(openingsWithSurcharge[weekdayIndex], (period) => {
    const { start, startMin, end, endMin } = period
    const periodStart = moment({ hours: start, minutes: startMin })
    const periodEnd = moment({ hours: end, minutes: endMin })
    if (start + startMin + end + endMin === 0) return true // opening 24 hours (0:0 ~ 0:0)
    if (periodEnd.isBefore(periodStart)) return moment().isBetween(periodStart, periodEnd.add(1, 'day')) // when closing time is earlier than the opening time.
    return moment().isBetween(periodStart, periodEnd, []) // current moment is within the certain time period.
  })
  const surchargePercent = _.get(openingsWithSurcharge, [weekdayIndex, periodIndex, 'surcharge', 'percent'], defaultSurcharge.percent)
  const totalSurcharge = total * (surchargePercent / 100)
  let surchargedTotal = total + totalSurcharge

  if (_.get(merchant, 'rounding')) {
    discountedTotal = round(discountedTotal, merchant.rounding)
    total = round(total, merchant.rounding)
    surchargedTotal = round(surchargedTotal, merchant.rounding)
  }

  let discountedTotalWithShipping = discountedTotal
  let shippingDiscount = 0
  let shippingFee = 0
  if (shipping) {
    // debugger
    shippingFee = _.get(shipping, 'totalFee', 0)
    if (_.get(shipping, 'discounts.0') && discountedTotal >= _.get(shipping, 'discounts.0.minOrderAmount')) {
      shippingDiscount = Math.min(_.get(shipping, 'discounts.0.amount'), shippingFee)
    }
    if (_.get(shipping, 'areas.0') && discountedTotal >= _.get(shipping, 'areas.0.discount.minOrderAmount')) {
      shippingDiscount = Math.min(_.get(shipping, 'areas.0.discount.amount'), shippingFee)
    }
    discountedTotalWithShipping = discountedTotal + shippingFee - shippingDiscount
  }

  const result = {
    total: Math.max(0, total),
    discountedTotal: Math.max(0, discountedTotal),
    surchargedTotal: Math.max(0, surchargedTotal),
    totalSurcharge: Math.max(0, surchargedTotal - total),
    totalDiscount: Math.max(0, total - discountedTotal),
    discountedTotalWithShipping: Math.max(0, discountedTotalWithShipping),
    shippingDiscount: Math.max(0, shippingDiscount),
    shippingFee: Math.max(0, shippingFee),
    discountedShippingFee: shippingFee - shippingDiscount,
  }
  // console.log(result)
  return result
}

const roundingTypes = {
  RoundingTypeNone: '',
  RoundingTypeUp: 'up',
  RoundingTypeDown: 'down',
  RoundingTypeOff: 'off',
}
const roundingMethods = {
  '': 'round',
  up: 'ceil',
  down: 'floor',
  off: 'round',
}
export function round (value, { type, digits }) {
  if (digits === 0 && type === roundingTypes.RoundingTypeNone) {
    digits = 1
  }
  const multipler = 10 ** digits
  const roundingMethod = roundingMethods[type] || roundingMethods['']
  return Math[roundingMethod](value * multipler) / multipler
}



// WEBPACK FOOTER //
// ./src/helpers/calculate.js